const sepaList = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SM',
];

export const sepaCheck = (iban) => {
  if (typeof iban !== 'string') return false;

  const ibanCountryCode = iban?.trim()?.slice(0, 2) || '';

  if (sepaList.includes(ibanCountryCode?.toUpperCase())) {
    return true;
  }

  return false;
};
